module.exports = {
  __init__: [ 'snapping' ],
  snapping: [ 'type', require(40) ]
};